import React from "react";
var __jsx = React.createElement;
import Button from "../../../../../../components/UiKit/Button/Button";
import BackButton from "../../../../../../components/UiKit/Buttons/BackButton/BackButton";
import Input from "../../../../../../components/UiKit/Input/Input";
import { useState } from "react";
import { useTranslation } from "@i18n";
import stl from "./UserEditNameComponent.module.css";
import useValidate from "@hooks/useValidate";
import useHelpers from "@hooks/useHelpers";
import { useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import useButtonLoading from "@hooks/useButtonLoading";
import useAlertsToaster from "@hooks/useAlertsToaster";
var UserEditNameComponent = function UserEditNameComponent() {
  var buttonLoading = useButtonLoading();
  var _useSession = useSession(),
    user = _useSession.user;
  var _useTranslation = useTranslation(["web_common", "web_user_account"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useAuthActions = useAuthActions(),
    remote_updateUserNameProfile = _useAuthActions.remote_updateUserNameProfile;
  var _useState = useState(user === null || user === void 0 ? void 0 : user.full_name),
    name = _useState[0],
    setName = _useState[1];
  var _useAlertsToaster = useAlertsToaster(),
    successToast = _useAlertsToaster.successToast;
  var handleOnChange = function handleOnChange(e) {
    setName(e.target.value);
    setError("");
  };
  var _useState2 = useState(""),
    error = _useState2[0],
    setError = _useState2[1];
  var _useValidate = useValidate(),
    validateName = _useValidate.validateName;
  var handleSubmit = function handleSubmit() {
    var error = validateName(name);
    if (error) return setError(error);
    remote_updateUserNameProfile(name).then(function () {
      navigateTo("/user/account/my-info");
      successToast(t("name_modified_successfully", {
        ns: "web_user_account"
      }));
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.mainContainer
  }, /*#__PURE__*/React.createElement(BackButton, {
    className: [stl.mb16, "m-hide"].join(" "),
    onClick: function onClick() {
      return navigateTo("/user/account/my-info");
    }
  }, /*#__PURE__*/React.createElement("span", null, t("back", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.form
  }, /*#__PURE__*/React.createElement("h2", {
    className: stl.title
  }, t("edit_name", {
    ns: "web_user_account"
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.subTitle
  }, t("enter_full_name_complete_request", {
    ns: "web_user_account"
  })), /*#__PURE__*/React.createElement(Input, {
    name: "full_name",
    type: "text",
    value: name,
    className: [stl.mb40].join(" "),
    label: t("full_name", {
      ns: "web_user_account"
    }),
    onChange: handleOnChange,
    error: error,
    maxLength: "25",
    minLength: "3"
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.button
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    onClick: handleSubmit,
    disabled: buttonLoading,
    className: ["blueBtn", stl.blueButtonDesign].join(" ")
  }, buttonLoading ? /*#__PURE__*/React.createElement("span", {
    className: stl.loader
  }) : t("edit_name_2", {
    ns: "web_user_account"
  }))))));
};
export default UserEditNameComponent;